import { connect } from 'react-redux'
import Procurement from './Procurement'

import componentWillMount from './Handlers/componentWillMount'

const mapStateToProps = () => ({})

const actionCreators = {
  componentWillMount,
}

export default connect(mapStateToProps, actionCreators)(Procurement)
